import React from 'react';
import Select from '~/components/forms/Select';
/**
 * PROPS
 * value = string
 * label = string
 * onChange(value) = func
 */

const AnchorNav = props => {
  return (
    <React.Fragment>
      <div className="form-group__anchor">
        <div className="inp__field--wrapper">
          <p className="inp__label">Заголовок</p>
          <input autoComplete="off" className="inp__field" type="text" />
        </div>
        <label className="inp">
          <p className="inp__label">Привязка к блоку</p>
          <Select
            value="device"
            options={[
              { value: '', label: 'Заголовок H1. “Модули программы”' },
              {
                value: '',
                label:
                  'Промо блок. “Программа двойного диплома МВА PwC + EADA имеет аккредитации...',
              },
            ]}
          />
        </label>

        <button className="btn btn--del"> Удалить</button>
      </div>
    </React.Fragment>
  );
};

export default AnchorNav;
